import { Location, Navigate, useLocation } from "react-router-dom";
import { TokenService } from "../../services/token.service";
import { setSessionLogoutReason } from "../../services/session-logout-reason";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location: Location = useLocation();
  const isInternalTokenValid: boolean = TokenService.isInternalTokenValid();

  if (isInternalTokenValid) {
    return <>{children}</>;
  }

  // Stage an "unauthenticated" notice so the public landing can surface
  // "Please log in to access this page." via SessionLogoutToast. sessionStorage
  // (not router state) is used so a cold-load into a protected URL still
  // triggers the message after the redirect settles.
  setSessionLogoutReason("unauthenticated");

  return <Navigate to="/" state={{ from: location.pathname }} replace />;
};
